import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/about/AboutContent.tsx");
